module.exports = __webpack_public_path__ + "static/media/Icon-envelope-open.5236487b.svg";